module.exports = __webpack_public_path__ + "media/images/logo/nombre_logo-dbd7a8e3e62d8f3bdde45f55411bc64a.png";